<template>
    <div class="slider">
        <h3 class="slider_title_safari">Ces escroqueries consistent à vendre de faux produits de placement en ligne</h3>
        <div v-for="i in [currentIndex]" :key="i" class="slider-content">
            <div class="slider_bouton">
                <button class="prev" @click="previous"></button>
                <button class="next" @click="next"></button>
            </div>
            <img :src="currentImg" class="image_slide"/>

        </div>
        <h5 class="caption_slideshow_safari">Exemples de sites frauduleux qui vendent de faux produits de placement en ligne</h5>
    </div>
</template>


<script>
    export default {
        name:"Slideshow",
        data(){
            return {
                images:['/img/bitcoin-storm.jpg',
                    '/img/cheptel-invest.jpg',
                    '/img/daxbase.jpg',
                    '/img/jms-invest.jpg',
                    '/img/lviewcapital.jpg',
                ],
                timer : null,
                currentIndex : 3,
                currentImg:'/img/daxbase.jpg',
            };
        },
        /* mounted: function() {
         this.startSlide();
       },*/

        methods:{
           /* startSlide: function() {
                this.timer = setInterval(this.next, 4000);
            },*/
            next(){

                this.currentIndex+=1;

            },
            previous(){
                this.currentIndex-=1;


            }
        },
        watch: {
            currentIndex: function() {
                this.currentImg = this.images[Math.abs(this.currentIndex) % this.images.length];
            }

        }
    }
</script>

<style scoped>
    .slider{
        height:100vh;
        width:100vw;
        display:flex;
        margin-top:5vh;
        flex-direction:column;
        justify-content:flex-start;
        align-items:center;

    }

    .image_slide {
        height: auto;
        width: 70vw;
        position:relative;
        left: 5vw;
    }


    .slider_bouton{
        position:relative;
        top:30vh;
        height:auto;
        width: 80vw;
        display:flex;
        justify-content: space-between;
    }

    .prev{
        background-image: url("/img/icon/fleche_direction_gauche.svg");
        background-size: contain;
        background-repeat: no-repeat;
    }

    .next{
        background-image: url("/img/icon/fleche_direction_droite.svg");
        background-size: contain;
        background-repeat: no-repeat;
    }


    .prev, .next {
        height:10vh;
        width: 5vw;
        cursor: pointer;
        border:0;
        user-select: none;
        background-color:white;
    }

    .slider_title_safari{
        text-align:center;
        width:80%;
        margin-bottom:0;
    }

    .caption_slideshow_safari{
         position:relative;
        top:-3vh;

    }

@media screen and (max-width:1000px){
    .slider{
        height:40vh;
        width:100vw;
        display:flex;
        margin-top:5vh;
        flex-direction:column;
        justify-content:flex-start;
        align-items:center;

    }

    .slider_bouton{
        position:relative;
        top:15vh;
        height:auto;
        width: 95vw;
        display:flex;
        justify-content: space-between;
    }


    .image_slide {
        height: auto;
        width: 85vw;
        position:relative;
        left: 5vw;
    }


}


</style>
